"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgoricco": {
    "30b5d0a1": [{
      "hkey": "0c02c1b6",
      "slug": "borgoricco",
      "name": "Borgoricco",
      "primary": true,
      "skipSearch": false
    }],
    "olmo": [{
      "hkey": "0c02c1b6",
      "slug": "borgoricco",
      "name": "Borgoricco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2505261": [{
      "hkey": "c831f1be",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-san-michele-delle-badesse": [{
      "hkey": "c831f1be",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;